import { useDateNow, useReduxState } from 'hooks';
import { addMonths } from 'date-fns';
import { Badge } from 'components/common';

import type { Achievement, AchievementCompletion } from 'shared-types';

interface Props {
  expirationDate?: string | null;
  isPendingRequest?: boolean;
  isInactive?: boolean;
  status: AchievementCompletion['status'];
  type: Achievement['type'];
}

const AchievementSimpleStatus = ({
  expirationDate,
  isPendingRequest,
  isInactive,
  status,
  type
}: Props) => {
  const { dateNow } = useDateNow();

  const { messages } = useReduxState();

  const expired = expirationDate && Date.parse(expirationDate) < dateNow;

  const expiring =
    !expired &&
    expirationDate &&
    new Date(Date.parse(expirationDate as string)) < addMonths(dateNow, 3);

  return (
    <Badge
      isRounded={false}
      {...(isInactive
        ? {
            icon: 'archive',
            text: messages.commonArchived
          }
        : expired
        ? {
            category: 'error-light',
            icon: 'check',
            text: messages.commonExpired
          }
        : expiring
        ? {
            category: 'warning-light',
            icon: 'check',
            text: messages.commonExpiring
          }
        : status === 'completed'
        ? {
            category: 'success-light',
            icon: 'check',
            text: messages.commonCompleted
          }
        : status === 'inprogress'
        ? { text: messages.commonInProgress }
        : status === 'not started'
        ? {
            text: ['conversation', 'tasklist'].includes(type)
              ? messages.commonNotStarted
              : messages.commonNoCompletion
          }
        : isPendingRequest
        ? {
            category: 'warning-light',
            icon: 'hourglass-start',
            text: messages.achievementRequested
          }
        : { text: messages.commonNotAdded })}
    />
  );
};

export default AchievementSimpleStatus;
